import { define, type, auto, Record, Collection } from 'type-r'
import ValidRecord from './valid_record'

@define 
export default class Address extends ValidRecord {
    @(type(String).required.as) address: string
    @(type(String).required.as) city: string
    @(type(String).required.as) state: string
    @(type(String).required.as) zip: string
}
